module.exports = __webpack_public_path__ + "img/appreciateLoginBackground.f29e1899.png";